import * as actions from "./actionsTypes";

const initialData = {
  loaderModalities: false,
  modalities: null,
  modalitiesFail: null,
  saveLoaderMdalities: false,
  modalitiesFormError: null,
  modalitiesLenght: 0
};

export default function ModalitiesReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_MODALITIES:
      return { ...state, loaderModalities: action.payload };

    case actions.GET_MODALITIES:
      return { ...state, modalities: action.payload };

    case actions.MODALITIES_FAIL:
      return { ...state, modalitiesFail: action.payload };

    case actions.SAVE_LOADER_MODALITIES:
      return { ...state, saveLoaderMdalities: action.payload };

    case actions.FORM_MODALITIES_FAIL:
      return { ...state, modalitiesFormError: action.payload };

    default:
      return state;
  }
}
